// ==========================================
// BUYERPROFILE.JSX - BUYER PROFILE PAGE
// Estate Experts - User Profile Management
// Updated with Change Password & Notifications
// ==========================================

import React, { useState, useEffect, useContext } from 'react';
import {
  FaCamera,
  FaEdit,
  FaTimes,
  FaSave,
  FaMapMarkerAlt,
  FaCheckCircle,
  FaLock,
  FaEye,
  FaEyeSlash
} from 'react-icons/fa';
import '../../../assets/css/Buyer/dashboard/Buyerprofile/buyerprofile.css';
import BuyerMasterLayout from '../../../layouts/BuyerMasterLayout';
import AppContext from 'context/AppContext';
import axios from 'axios';

function BuyerProfile() {
  // ==========================================
  // STATE MANAGEMENT
  // ==========================================
  const { baseUrl, loggedInBuyer, baseUrlForFiles, authToken, setLoggedInBuyer } = useContext(AppContext);
  const [isLoading, setIsLoading] = useState(true);
  const [showSuccessMessage, setShowSuccessMessage] = useState(false);
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [password, setPassword] = useState("");
  const [email, setEmail] = useState("");
  const [phonenumber, setPhoneNumber] = useState();
  const [location, setLocation] = useState("");
  // Modal state
  const [isPasswordModalOpen, setIsPasswordModalOpen] = useState(false);

  const [showCurrentPassword, setShowCurrentPassword] = useState(false);
  const [showNewPassword, setShowNewPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const changePassword = () => {
    const formData = new FormData();
    formData.append("currentPassword", passwordData.currentPassword);
    formData.append("newPassword", passwordData.newPassword);
    formData.append("confirmPassword", passwordData.confirmPassword);
    axios
      .post(`${baseUrl}/buyer/auth/changePassword`, formData, {
        headers: {
          "Content-Type": "multipart/form-data",
          "Authorization": `Bearer ${authToken}`
        },
      })
      .then((response) => {
        console.log(response.data);
        if (response.data.success) {
          alert(response.data.message);
          closePasswordModal();
          setPasswordData({
            currentPassword: "",
            newPassword: "",
            confirmPassword: ""
          });
        }
      })
      .catch((error) => {
        console.log(error);
      });

  };

  // Password form data
  const [passwordData, setPasswordData] = useState({
    currentPassword: '',
    newPassword: '',
    confirmPassword: ''
  });

  // Edit mode states
  const [isEditingPersonal, setIsEditingPersonal] = useState(false);

  // Notification states
  const [notifications, setNotifications] = useState({
    inApp: true,
    email: true
  });

  // Profile data state
  const [profileData, setProfileData] = useState({
    // firstName: '',
    // lastName: '',
    // role: '',
    // location: '',
    // avatar: '',
    // email: '',
    // phone: '',
    // country: '',
    // city: ''
  });

  // Temporary edit data
  const [tempData, setTempData] = useState({});

  // ==========================================
  // LOAD USER DATA FROM LOCALSTORAGE
  // ==========================================

  useEffect(() => {

    console.log("useEffect called from the buyer profile", loggedInBuyer);
    setTimeout(() => {
      const userProfile = JSON.parse(localStorage.getItem('userProfile') || '{}');
      const savedProfile = JSON.parse(localStorage.getItem('buyerProfile') || '{}');
      const savedNotifications = JSON.parse(localStorage.getItem('buyerNotifications') || '{"inApp": true, "email": true}');

      const mergedData = {
      };

      setProfileData(mergedData);
      setNotifications(savedNotifications);
      setIsLoading(false);
    }, 800);
  }, []);

  // ==========================================
  // HANDLE AVATAR UPLOAD
  // ==========================================
  const handleAvatarChange = (e) => {
    const file = e.target.files?.[0];
    if (!file) return;

    if (!file.type.startsWith("image/")) {
      alert("Please select an image file.");
      e.target.value = "";
      return;
    }
    if (file.size > 5 * 1024 * 1024) {
      alert("Image size should be less than 5MB.");
      e.target.value = "";
      return;
    }
    const formData = new FormData();
    formData.append("profileImage", file);
    axios.post(
      `${baseUrl}/buyer/profile/updateProfileImage`,
      formData,
      {
        headers: {
          Authorization: `Bearer ${authToken}`,
        },
      }
    )
      .then((response) => {
        if (response.data.success) {
          // Backend se updated image path lena
          const imagePath =
            response.data.buyer?.profileImage ||
            response.data.profileImage;

          const updatedBuyer = {
            ...loggedInBuyer,
            ...(response.data.buyer || {}),
            profileImage: imagePath,
          };

          setLoggedInBuyer(updatedBuyer);

          localStorage.setItem(
            "loggedInBuyer",
            JSON.stringify(updatedBuyer)
          );

          localStorage.setItem(
            "buyerProfile",
            JSON.stringify(updatedBuyer)
          );

          showSuccess("Profile picture updated successfully!");
        } else {
          alert(response.data.message || "Image upload failed.");
        }
      })
      .catch((error) => {
        console.error("Buyer image upload error:", error.response?.data || error);
        alert(
          error.response?.data?.message ||
          "Unable to upload profile picture."
        );
      })
      .finally(() => {
        e.target.value = "";
      });
  };

  // ==========================================
  // PASSWORD MODAL HANDLERS
  // ==========================================

  const openPasswordModal = () => {
    setIsPasswordModalOpen(true);
    setPasswordData({
      currentPassword: '',
      newPassword: '',
      confirmPassword: ''
    });
  };

  const closePasswordModal = () => {
    setIsPasswordModalOpen(false);
    setPasswordData({
      currentPassword: '',
      newPassword: '',
      confirmPassword: ''
    });
    setShowCurrentPassword(false);
    setShowNewPassword(false);
    setShowConfirmPassword(false);
  };

  const handlePasswordChange = (field, value) => {
    setPasswordData({
      ...passwordData,
      [field]: value
    });
  };

  const handlePasswordSubmit = () => {
    // Validation
    if (!passwordData.currentPassword || !passwordData.newPassword || !passwordData.confirmPassword) {
      alert('Please fill all password fields');
      return;
    }

    if (passwordData.newPassword !== passwordData.confirmPassword) {
      alert('New password and confirm password do not match');
      return;
    }

    if (passwordData.newPassword.length < 8) {
      alert('Password must be at least 8 characters long');
      return;
    }

    // Save password (in real app, this would call an API)
    console.log('Password changed successfully');
    closePasswordModal();
    showSuccess('Password changed successfully!');
  };

  // ==========================================
  // NOTIFICATION HANDLERS
  // ==========================================

  const toggleNotification = (type) => {
    const newNotifications = {
      ...notifications,
      [type]: !notifications[type]
    };
    setNotifications(newNotifications);
    localStorage.setItem('buyerNotifications', JSON.stringify(newNotifications));
    showSuccess('Notification settings updated!');
  };

  // ==========================================
  // HANDLE INPUT CHANGES
  // ==========================================

  const handleInputChange = (field, value) => {
    setProfileData({
      ...profileData,
      [field]: value
    });
  };

  // ==========================================
  // EDIT MODE HANDLERS
  // ==========================================

  const startEditingPersonal = () => {
    setFirstName(loggedInBuyer?.firstName || "");
    setLastName(loggedInBuyer?.lastName || "");
    setEmail(loggedInBuyer?.email || "");
    setPhoneNumber(loggedInBuyer?.phonenumber || "");
    setLocation(loggedInBuyer?.location || "");

    setIsEditingPersonal(true);
  };

  const cancelEditing = () => {
    setProfileData({ ...tempData });
    setIsEditingPersonal(false);
  };

  // ==========================================
  // SAVE CHANGES
  // ==========================================

  const savePersonalInfo = () => {
    saveProfileToLocalStorage(loggedInBuyer);
    setIsEditingPersonal(false);
    showSuccess('Profile updated successfully!');
  };

  const saveProfileToLocalStorage = (data) => {
    localStorage.setItem('buyerProfile', JSON.stringify(data));

    const userProfile = JSON.parse(localStorage.getItem('userProfile') || '{}');
    userProfile.name = `${data.firstName} ${data.lastName}`;
    userProfile.email = data.email;
    localStorage.setItem('userProfile', JSON.stringify(userProfile));
  };

  const showSuccess = (message = 'Profile updated successfully!') => {
    setShowSuccessMessage(message);
    setTimeout(() => {
      setShowSuccessMessage(false);
    }, 3000);
  };


  const updateProfile = () => {
    const formData = new FormData();

    formData.append("id", loggedInBuyer.id);
    formData.append("firstName", firstName);
    formData.append("lastName", lastName);
    formData.append("email", email);
    formData.append("phonenumber", phonenumber);
    formData.append("location", location);

    axios.post(
      `${baseUrl}/buyer/profile/updateProfile`,
      formData,
      {
        headers: {
          "Content-Type": "multipart/form-data",
          Authorization: `Bearer ${authToken}`,
        },
      }
    )
      .then((response) => {
        console.log("Update Response:", response.data);

        if (response.data.success) {

          alert(response.data.message);

          const updatedBuyer = {
            ...loggedInBuyer,
            firstName: firstName,
            lastName: lastName,
            email: email,
            phonenumber: phonenumber,
            location: location
          };

          // React state immediately update
          setLoggedInBuyer(updatedBuyer);

          // LocalStorage update
          localStorage.setItem(
            "loggedInBuyer",
            JSON.stringify(updatedBuyer)
          );

          localStorage.setItem(
            "buyerProfile",
            JSON.stringify(updatedBuyer)
          );

          setIsEditingPersonal(false);

        } else {
          alert(response.data.message);
        }
      })
      .catch((error) => {
        console.log(
          "Update Error:",
          error.response?.data || error
        );

        alert(
          error.response?.data?.message ||
          "Profile update failed"
        );
      });
  };
  // ==========================================
  // RENDER LOADING STATE
  // ==========================================

  if (isLoading) {
    return (
      <BuyerMasterLayout pageTitle='Profile'>
        <div className="buyerprofile-container">
          <div className="buyerprofile-loading">
            <div className="buyerprofile-spinner"></div>
            Loading profile...
          </div>
        </div>
      </BuyerMasterLayout>
    );
  }

  // ==========================================
  // RENDER PROFILE PAGE
  // ==========================================

  return (
    <BuyerMasterLayout pageTitle='Profile'>
      <div className="buyerprofile-container">
        {/* Page Title */}
        {/* <h1 className="buyerprofile-page-title">Buyer Profile</h1> */}

        {/* Success Message */}
        {showSuccessMessage && (
          <div className="buyerprofile-success-message">
            <FaCheckCircle className="buyerprofile-success-icon" />
            {showSuccessMessage}
          </div>
        )}

        {/* ==========================================
            PROFILE HEADER CARD
            ========================================== */}
        <div className="buyerprofile-header-card">
          <div className="buyerprofile-avatar-section">
            {/* Avatar with Upload */}
            <div className="buyerprofile-avatar-wrapper">
              <img
                src={
                  loggedInBuyer?.profileImage
                    ? `${baseUrlForFiles.replace(/\/$/, "")}/${loggedInBuyer.profileImage.replace(/^\//, "")}`
                    : "/default-avatar.png"
                }
                alt={`${loggedInBuyer?.firstName || ""} ${loggedInBuyer?.lastName || ""}`}
                className="buyerprofile-avatar"
              />
              <label className="buyerprofile-avatar-upload-btn" title="Change profile picture">
                <FaCamera />
                <input
                  type="file"
                  accept="image/*"
                  onChange={handleAvatarChange}
                  className="buyerprofile-avatar-input"
                />
              </label>
            </div>

            {/* Profile Info */}
            <div className="buyerprofile-header-info">
              <h2 className="buyerprofile-name">
                {loggedInBuyer.firstName} {loggedInBuyer.lastName}
              </h2>
              <p className="buyerprofile-role">{loggedInBuyer.role}</p>
              <p className="buyerprofile-location">
                <FaMapMarkerAlt />
                {loggedInBuyer.location}
              </p>
            </div>
          </div>

          {/* Change Password Button */}
          <button
            className="buyerprofile-change-password-btn"
            onClick={openPasswordModal}
          >
            <FaLock /> Change Password
          </button>
        </div>

        {/* ==========================================
            PERSONAL INFORMATION SECTION
            ========================================== */}
        <div className="buyerprofile-section">
          <div className="buyerprofile-section-header">
            <h3 className="buyerprofile-section-title">Personal Information</h3>
            {!isEditingPersonal ? (
              <button
                className="buyerprofile-section-edit-btn"
                onClick={startEditingPersonal}
              >
                <FaEdit /> Edit
              </button>
            ) : (
              <button
                className="buyerprofile-section-edit-btn editing"
                onClick={cancelEditing}
              >
                <FaTimes /> Cancel
              </button>
            )}
          </div>

          <div className="buyerprofile-form-grid">
            {/* First Name */}
            <div className="buyerprofile-form-group">
              <label className="buyerprofile-form-label">First Name</label>
              {!isEditingPersonal ? (
                <div className="buyerprofile-display-value">{loggedInBuyer.firstName}</div>
              ) : (
                <input
                  type="text"
                  className="buyerprofile-form-input"
                  value={firstName}
                  onChange={(e) =>
                    setFirstName(e.target.value)
                  }
                  placeholder="Enter first name"
                />
              )}
            </div>

            {/* Last Name */}
            <div className="buyerprofile-form-group">
              <label className="buyerprofile-form-label">Last Name</label>
              {!isEditingPersonal ? (
                <div className="buyerprofile-display-value">{loggedInBuyer.lastName}</div>
              ) : (
                <input
                  type="text"
                  className="buyerprofile-form-input"
                  value={lastName}
                  onChange={(e) => setLastName(e.target.value)}
                  placeholder="Enter last name"
                />
              )}
            </div>

            {/* Email Address */}
            <div className="buyerprofile-form-group">
              <label className="buyerprofile-form-label">Email Address</label>
              {!isEditingPersonal ? (
                <div className="buyerprofile-display-value">{loggedInBuyer.email}</div>
              ) : (
                <input
                  type="email"
                  className="buyerprofile-form-input"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  placeholder="Enter email address"
                />
              )}
            </div>

            {/* Phone */}
            <div className="buyerprofile-form-group">
              <label className="buyerprofile-form-label">Phone</label>
              {!isEditingPersonal ? (
                <div className="buyerprofile-display-value">{loggedInBuyer.phonenumber}</div>
              ) : (
                <input
                  type="tel"
                  className="buyerprofile-form-input"
                  value={phonenumber}
                  onChange={(e) => setPhoneNumber(e.target.value)}
                  placeholder="Enter phone number"
                />
              )}
            </div>

            {/* Location */}
            <div className="buyerprofile-form-group">
              <label className="buyerprofile-form-label">Location</label>
              {!isEditingPersonal ? (
                <div className="buyerprofile-display-value">{loggedInBuyer.location}</div>
              ) : (
                <input
                  type="text"
                  className="buyerprofile-form-input"
                  value={location}
                  onChange={(e) => setLocation(e.target.value)}
                  placeholder="Enter location"
                />
              )}
            </div>

            {/* City / State */}
            {/* <div className="buyerprofile-form-group">
              <label className="buyerprofile-form-label">City / State</label>
              {!isEditingPersonal ? (
                <div className="buyerprofile-display-value">{loggedInBuyer.city}</div>
              ) : (
                <input
                  type="text"
                  className="buyerprofile-form-input"
                  value={loggedInBuyer.city}
                  onChange={(e) => handleInputChange('city', e.target.value)}
                  placeholder="Enter city/state"
                />
              )}
            </div> */}
          </div>

          {/* Action Buttons */}
          {isEditingPersonal && (
            <div className="buyerprofile-action-buttons">
              <button
                className="buyerprofile-cancel-btn"
                onClick={cancelEditing}
              >
                <FaTimes /> Cancel
              </button>
              <button
                className="buyerprofile-save-btn"
                onClick={updateProfile}
              >
                <FaSave /> Save Changes
              </button>
            </div>
          )}
        </div>



        {/* ==========================================
            CHANGE PASSWORD MODAL
            ========================================== */}
        {isPasswordModalOpen && (
          <div className="buyerprofile-modal-overlay" onClick={closePasswordModal}>
            <div className="buyerprofile-modal" onClick={(e) => e.stopPropagation()}>

              {/* Modal Header */}
              <div className="buyerprofile-modal-header">
                <h3 className="buyerprofile-modal-title">
                  <FaLock /> Change Password
                </h3>
                <button
                  className="buyerprofile-modal-close-btn"
                  onClick={closePasswordModal}
                >
                  <FaTimes />
                </button>
              </div>

              {/* Modal Body */}
              <div className="buyerprofile-modal-body">
                <form className="buyerprofile-password-form" onSubmit={(e) => e.preventDefault()}>

                  {/* Current Password */}
                  <div className="buyerprofile-password-group">
                    <label className="buyerprofile-password-label">Current Password</label>
                    <div className="buyerprofile-password-input-wrapper">
                      <input
                        type={showCurrentPassword ? "text" : "password"}
                        className="buyerprofile-password-input"
                        value={passwordData.currentPassword}
                        onChange={(e) => handlePasswordChange('currentPassword', e.target.value)}
                        placeholder="Enter current password"
                      />
                      <button
                        type="button"
                        className="buyerprofile-password-toggle"
                        onClick={() => setShowCurrentPassword(!showCurrentPassword)}
                      >
                        {showCurrentPassword ? <FaEyeSlash /> : <FaEye />}
                      </button>
                    </div>
                  </div>

                  {/* New Password */}
                  <div className="buyerprofile-password-group">
                    <label className="buyerprofile-password-label">New Password</label>
                    <div className="buyerprofile-password-input-wrapper">
                      <input
                        type={showNewPassword ? "text" : "password"}
                        className="buyerprofile-password-input"
                        value={passwordData.newPassword}
                        onChange={(e) => handlePasswordChange('newPassword', e.target.value)}
                        placeholder="Enter new password"
                      />
                      <button
                        type="button"
                        className="buyerprofile-password-toggle"
                        onClick={() => setShowNewPassword(!showNewPassword)}
                      >
                        {showNewPassword ? <FaEyeSlash /> : <FaEye />}
                      </button>
                    </div>
                  </div>

                  {/* Confirm Password */}
                  <div className="buyerprofile-password-group">
                    <label className="buyerprofile-password-label">Confirm Password</label>
                    <div className="buyerprofile-password-input-wrapper">
                      <input
                        type={showConfirmPassword ? "text" : "password"}
                        className="buyerprofile-password-input"
                        value={passwordData.confirmPassword}
                        onChange={(e) => handlePasswordChange('confirmPassword', e.target.value)}
                        placeholder="Confirm new password"
                      />
                      <button
                        type="button"
                        className="buyerprofile-password-toggle"
                        onClick={() => setShowConfirmPassword(!showConfirmPassword)}
                      >
                        {showConfirmPassword ? <FaEyeSlash /> : <FaEye />}
                      </button>
                    </div>
                  </div>

                  {/* Action Buttons */}
                  <div className="buyerprofile-modal-actions">
                    <button
                      type="button"
                      className="buyerprofile-modal-cancel-btn"
                      onClick={closePasswordModal}
                    >
                      <FaTimes /> Cancel
                    </button>
                    <button
                      type="button"
                      className="buyerprofile-modal-save-btn"
                      onClick={changePassword}
                    >
                      <FaSave /> Save Password
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        )}

      </div>
    </BuyerMasterLayout>
  );
}

export default BuyerProfile;